import { render } from "./KeyPointsCard.vue?vue&type=template&id=491679f5"
import script from "./KeyPointsCard.vue?vue&type=script&lang=js"
export * from "./KeyPointsCard.vue?vue&type=script&lang=js"

import "./KeyPointsCard.vue?vue&type=style&index=0&id=491679f5&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__